import { useTenant } from "hooks/settings";
import React, { useEffect, useState } from "react";
import { useGetBackupsQuery } from "src/store/api/generatedApi";

const checkBackupsPollMS = 3000;

export const resolvedBackupStatuses = [
  "failed",
  "failed_suboptimal",
  "succeeded_suboptimal",
  "succeeded",
];

export const useBackups = (planId: number) => {
  const tenant = useTenant();
  const backups = useGetBackupsQuery({
    tenantName: tenant,
    planId: planId,
  });

  const timeoutRef = React.useRef<null | ReturnType<typeof setTimeout>>(null);

  React.useEffect(() => {
    if (
      backups.isSuccess &&
      backups.currentData?.backups.some(
        (backup) => !resolvedBackupStatuses.includes(backup.status)
      )
    ) {
      timeoutRef.current = setTimeout(() => {
        void backups.refetch();
      }, checkBackupsPollMS);
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
    // eslint-disable-next-line @eslint-react/exhaustive-deps -- use specific properties; the whole RTK query object is unstable
  }, [backups.isSuccess, backups.currentData, backups.refetch]);

  return backups;
};

// Backup rows may lag the search result commit, so defer the initial query to
// avoid caching a transient empty response.
const checkBackupsInitialDelay = 4000;

export const useShouldFetchBackups = (): boolean => {
  const [shouldFetchBackups, setShouldFetchBackups] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetchBackups(true);
    }, checkBackupsInitialDelay);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return shouldFetchBackups;
};
